import { render } from "./BuyTransport.vue?vue&type=template&id=18825463&scoped=true"
import script from "./BuyTransport.vue?vue&type=script&lang=js"
export * from "./BuyTransport.vue?vue&type=script&lang=js"

import "./BuyTransport.vue?vue&type=style&index=0&id=18825463&scoped=true&lang=css"

import exportComponent from "C:\\Users\\knhmb\\Documents\\Khalid\\Job\\MarvelConnect Technology\\Projects\\One Shop Online Shopping\\one-shop-online-shopping\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18825463"]])

export default __exports__